import {
  oscrReportTypesDictionary,
  bfReportTypesDictionary,
} from "./constants";
import {
  RangeSelectFilter,
  SearchValueFilter,
  UiValue,
  SingleValuesFilter,
  PaginationFilter,
  KeyValue,
} from "../interfaces";
export const multiCert = [];

export const eventCode = Object.keys(oscrReportTypesDictionary).map(
  (reportType: string) => {
    return {
      label: reportType,
      value: oscrReportTypesDictionary[reportType],
      checked: true,
    };
  },
);

export const eventCodeBf = Object.keys(bfReportTypesDictionary).map(
  (reportType: string) => {
    return {
      label: reportType,
      value: bfReportTypesDictionary[reportType],
      checked: true,
    };
  },
);

export const historicalDisplayFields = [
  "TOTAL",
  "BANKS",
  "BRANCHES",
  "BRANCHIN",
  "UNIT",
  "ALLOTHER",
  "OFFICES",
  "New_Char",
  "REL_CO",
  "UNASSIST",
  "MERGERS",
  "PAID_OFF",
  "OTHER",
  "FD_SAIF",
  "FD_BIF",
  "TOT_FDIC",
  "OT_SAIF",
  "TOT_OTS",
  "TOT_SAVE",
  "OT_BIF",
  "CONS",
  "newcount",
  "alsonew",
  "chrtrest",
  "chartoth",
  "combos",
  "tomerg",
  "comboass",
  "tofail",
  "liqasstd",
  "tortc",
  "liqunass",
  "tochrt",
  "MISSADJ",
  "SAVINGS",
  "INTINC",
  "EINTEXP",
  "NIM",
  "NONII",
  "NONIX",
  "ELNATR",
  "ITAXR",
  "IGLSEC",
  "ITAX",
  "EXTRA",
  "NETINC",
  "COUNT",
  "PTXNOINC",
  "ILNDOM",
  "ILNFOR",
  "ILS",
  "ILNLS",
  "ISC",
  "ITRADE",
  "IFREPO",
  "ICHBAL",
  "TINTINC",
  "ILNS",
  "EDEPDOM",
  "EDEPFOR",
  "EDEP",
  "EFREPP",
  "NEW6_1",
  "ESUBND",
  "TOINTEXP",
  "OTHBORR",
  "EFHLBADV",
  "ISERCHG",
  "OONONII",
  "ESAL",
  "EPREMAGG",
  "EOTHNINT",
  "IFEE",
  "EAMINTAN",
  "DRLNLS",
  "CRLNLS",
  "NTLNLS",
  "EQCDIVP",
  "EQCDIVC",
  "EQCDIV",
  "NUMEMP",
  "NCHGREC",
  "CHBAL",
  "SC",
  "LNLSGR",
  "LNATRES",
  "LNLSNET",
  "OEA",
  "BKPREM",
  "ORE",
  "INTAN",
  "NEW9_1",
  "ASSET",
  "ORET",
  "OTHASST",
  "SCUST",
  "SCAGE",
  "SCMUNI",
  "NEW10_1",
  "SCEQ",
  "SCMV",
  "NEW10_2",
  "NEW10_3",
  "CORPBNDS",
  "SCUS",
  "SCRES",
  "TRADES",
  "SCMTGBK",
  "LNRE",
  "LNDEP",
  "LNAG",
  "LNCI",
  "LNCON",
  "LNMUNI",
  "NEW11_1",
  "LS",
  "LNLS",
  "UNINC",
  "OTLNCNTA",
  "LNRECONS",
  "LNRERES",
  "LNREMULT",
  "LNREAG",
  "LNRENRES",
  "LNREDOM",
  "LNREFOR",
  "LNRELOC",
  "LNRESRE",
  "LNCRCD",
  "LNCONOTH",
  "LNAUTO",
  "LNMOBILE",
  "LNSP",
  "LNCONOT1",
  "LNALLOTH",
  "DEP",
  "NEW14_1",
  "SUBND",
  "NEW14_2",
  "NEW14_3",
  "EQPP",
  "EQCS",
  "EQSUR",
  "NEW14_4",
  "EQOTHCC",
  "EQNM",
  "OTHNBORR",
  "SUBLLPF",
  "OTHLIAB",
  "LIAB",
  "EQUPTOT",
  "EQNWCERT",
  "LIABEQ",
  "NEW15_1",
  "NEW15_2",
  "NEW15_3",
  "NEW15_4",
  "DEPI",
  "DEPNI",
  "DDT",
  "NEW15_5",
  "NTRTIME",
  "NEW15_7",
  "TRN",
  "NTR",
  "NTRTMLG",
  "IRAKEOGH",
  "BRO",
  "CHBALI",
  "FREPO",
  "INTBAST",
  "FREPP",
  "MTGLS",
  "NEW16_1",
  "INTBLIB",
  "TRADE",
  "OTHBFHLB",
  "OINTBOR",
  "DEPNIFOR",
  "DEPIFOR",
  "DEPFOR",
  "P3LNLS",
  "P9LNLS",
  "TPD",
  "NALNLS",
  "NCLNLS",
  "STNAME",
  "NETIMIN",
];

export const failuresDisplayFields = [
  "NAME",
  "CERT",
  "FIN",
  "CITYST",
  "FAILDATE",
  "SAVR",
  "RESTYPE",
  "COST",
  "RESTYPE1",
  "CHCLASS1",
  "QBFDEP",
  "QBFASSET",
];

export const CBSDisplayFields = ["TOTAL", "BRANCHES", "OFFICES", "New_Char"];

export const CBFDisplayFields = ["BANKS", "ASSET", "DEP", "EQNM", "NETINC"];

export const SISDisplayFields = ["SAVINGS", "newcount", "chartoth", "tochrt"];

export const SIFDisplayFields = ["COUNT", "ASSET", "DEP", "EQNM", "NETINC"];

export const defaultSelectedStatesValue = [0];

export const selectedStates = [
  { label: "United States & Other Areas", value: 0 },
  { label: "United States (50 states and DC)", value: 99 },
  { label: "Other Areas", value: 98 },
  { label: "Alabama", value: 1 },
  { label: "Alaska", value: 2 },
  { label: "American Samoa", value: 60 },
  { label: "Arizona", value: 4 },
  { label: "Arkansas", value: 5 },
  { label: "California", value: 6 },
  { label: "Colorado", value: 8 },
  { label: "Connecticut", value: 9 },
  { label: "Delaware", value: 10 },
  { label: "District of Columbia", value: 11 },
  { label: "Federated States of Micronesia", value: 64 },
  { label: "Florida", value: 12 },
  { label: "Georgia", value: 13 },
  { label: "Guam", value: 66 },
  { label: "Hawaii", value: 15 },
  { label: "Idaho", value: 16 },
  { label: "Illinois", value: 17 },
  { label: "Indiana", value: 18 },
  { label: "Iowa", value: 19 },
  { label: "Kansas", value: 20 },
  { label: "Kentucky", value: 21 },
  { label: "Louisiana", value: 22 },
  { label: "Maine", value: 23 },
  { label: "Marshall Islands", value: 68 },
  { label: "Maryland", value: 24 },
  { label: "Massachusetts", value: 25 },
  { label: "Michigan", value: 26 },
  { label: "Minnesota", value: 27 },
  { label: "Mississippi", value: 28 },
  { label: "Missouri", value: 29 },
  { label: "Montana", value: 30 },
  { label: "Nebraska", value: 31 },
  { label: "Nevada", value: 32 },
  { label: "New Hampshire", value: 33 },
  { label: "New Jersey", value: 34 },
  { label: "New Mexico", value: 35 },
  { label: "New York", value: 36 },
  { label: "North Carolina", value: 37 },
  { label: "North Dakota", value: 38 },
  { label: "Northern Mariana Islands", value: 69 },
  { label: "Ohio", value: 39 },
  { label: "Oklahoma", value: 40 },
  { label: "Oregon", value: 41 },
  { label: "Palau", value: 70 },
  { label: "Pennsylvania", value: 42 },
  { label: "Puerto Rico", value: 72 },
  { label: "Rhode Island", value: 44 },
  { label: "South Carolina", value: 45 },
  { label: "South Dakota", value: 46 },
  { label: "Tennessee", value: 47 },
  { label: "Texas", value: 48 },
  { label: "Utah", value: 49 },
  { label: "Vermont", value: 50 },
  { label: "Virgin Islands", value: 78 },
  { label: "Virginia", value: 51 },
  { label: "Washington", value: 53 },
  { label: "West Virginia", value: 54 },
  { label: "Wisconsin", value: 55 },
  { label: "Wyoming", value: 56 },
];

export const activeStatus = [
  { label: "Active & Inactive", value: [0, 1] },
  { label: "Active", value: [1] },
  { label: "Inactive", value: [0] },
];

export const selectedStatesAlpha = [
  { label: "Alabama", value: "AL", isState: true },
  { label: "Alaska", value: "AK", isState: true },
  { label: "American Samoa", value: "AS", isState: false },
  { label: "Arizona", value: "AZ", isState: true },
  { label: "Arkansas", value: "AR", isState: true },
  { label: "California", value: "CA", isState: true },
  { label: "Colorado", value: "CO", isState: true },
  { label: "Connecticut", value: "CT", isState: true },
  { label: "Delaware", value: "DE", isState: true },
  { label: "District of Columbia", value: "DC", isState: true },
  { label: "Federated States of Micronesia", value: "FM", isState: false },
  { label: "Florida", value: "FL", isState: true },
  { label: "Georgia", value: "GA", isState: true },
  { label: "Guam", value: "GU", isState: false },
  { label: "Hawaii", value: "HI", isState: true },
  { label: "Idaho", value: "ID", isState: true },
  { label: "Illinois", value: "IL", isState: true },
  { label: "Indiana", value: "IN", isState: true },
  { label: "Iowa", value: "IA", isState: true },
  { label: "Kansas", value: "KS", isState: true },
  { label: "Kentucky", value: "KY", isState: true },
  { label: "Louisiana", value: "LA", isState: true },
  { label: "Maine", value: "ME", isState: true },
  { label: "Marshall Islands", value: "MH", isState: false },
  { label: "Maryland", value: "MD", isState: true },
  { label: "Massachusetts", value: "MA", isState: true },
  { label: "Michigan", value: "MI", isState: true },
  { label: "Minnesota", value: "MN", isState: true },
  { label: "Mississippi", value: "MS", isState: true },
  { label: "Missouri", value: "MO", isState: true },
  { label: "Montana", value: "MT", isState: true },
  { label: "Nebraska", value: "NE", isState: true },
  { label: "Nevada", value: "NV", isState: true },
  { label: "New Hampshire", value: "NH", isState: true },
  { label: "New Jersey", value: "NJ", isState: true },
  { label: "New Mexico", value: "NM", isState: true },
  { label: "New York", value: "NY", isState: true },
  { label: "North Carolina", value: "NC", isState: true },
  { label: "North Dakota", value: "ND", isState: true },
  { label: "Northern Mariana Islands", value: "MP", isState: false },
  { label: "Ohio", value: "OH", isState: true },
  { label: "Oklahoma", value: "OK", isState: true },
  { label: "Oregon", value: "OR", isState: true },
  { label: "Palau", value: "PW", isState: false },
  { label: "Pennsylvania", value: "PA", isState: true },
  { label: "Puerto Rico", value: "PR", isState: false },
  { label: "Rhode Island", value: "RI", isState: true },
  { label: "South Carolina", value: "SC", isState: true },
  { label: "South Dakota", value: "SD", isState: true },
  { label: "Tennessee", value: "TN", isState: true },
  { label: "Texas", value: "TX", isState: true },
  { label: "Utah", value: "UT", isState: true },
  { label: "Vermont", value: "VT", isState: true },
  { label: "U.S. Virgin Islands", value: "VI", isState: false },
  { label: "Virginia", value: "VA", isState: true },
  { label: "Washington", value: "WA", isState: true },
  { label: "West Virginia", value: "WV", isState: true },
  { label: "Wisconsin", value: "WI", isState: true },
  { label: "Wyoming", value: "WY", isState: true },
];

export const getStateName = (array: KeyValue[], value: any) => {
  if (value === "ALL") {
    return "All";
  } else {
    const stateName = array.find(e => e.value === value);
    return stateName?.label || value;
  }
};

export const sodStatesArray = [
  "Alabama",
  "Alaska",
  "American Samoa",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "District Of Columbia",
  "Federated States Of Micronesia",
  "Florida",
  "Georgia",
  "Guam",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Marshall Islands",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "New York",
  "North Carolina",
  "North Dakota",
  "Northern Mariana Islands",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Palau",
  "Pennsylvania",
  "Puerto Rico",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Vermont",
  "Virgin Islands Of The U.S.",
  "Virginia",
  "Washington",
  "West Virginia",
  "Wisconsin",
  "Wyoming",
];

export const stateNameToAbbrv: KeyValue = {
  "Alabama": "AL",
  "Alaska": "AK",
  "American Samoa": "AS",
  "Arizona": "AZ",
  "Arkansas": "AR",
  "California": "CA",
  "Colorado": "CO",
  "Connecticut": "CT",
  "Delaware": "DE",
  "District Of Columbia": "DC",
  "Federated States Of Micronesia": "FM",
  "Florida": "FL",
  "Georgia": "GA",
  "Guam": "GU",
  "Hawaii": "HI",
  "Idaho": "ID",
  "Illinois": "IL",
  "Indiana": "IN",
  "Iowa": "IA",
  "Kansas": "KS",
  "Kentucky": "KY",
  "Louisiana": "LA",
  "Maine": "ME",
  "Marshall Islands": "MH",
  "Maryland": "MD",
  "Massachusetts": "MA",
  "Michigan": "MI",
  "Minnesota": "MN",
  "Mississippi": "MS",
  "Missouri": "MO",
  "Montana": "MT",
  "Nebraska": "NE",
  "Nevada": "NV",
  "New Hampshire": "NH",
  "New Jersey": "NJ",
  "New Mexico": "NM",
  "New York": "NY",
  "North Carolina": "NC",
  "North Dakota": "ND",
  "Northern Mariana Islands": "MP",
  "Ohio": "OH",
  "Oklahoma": "OK",
  "Oregon": "OR",
  "Palau": "PW",
  "Pennsylvania": "PA",
  "Puerto Rico": "PR",
  "Rhode Island": "RI",
  "South Carolina": "SC",
  "South Dakota": "SD",
  "Tennessee": "TN",
  "Texas": "TX",
  "Utah": "UT",
  "Vermont": "VT",
  "Virgin Islands Of The U.S.": "VI",
  "Virginia": "VA",
  "Washington": "WA",
  "West Virginia": "WV",
  "Wisconsin": "WI",
  "Wyoming": "WY",
};

export const selectedStatesAlphaBHC = selectedStatesAlpha;

export const selectedInsuranceFunds = [
  { label: "Bank Insurance Fund (BIF)", value: "BIF" },
  { label: "Resolution Trust Corporation (RTC)", value: "RTC" },
  {
    label: "Federal Savings and Loan Insurance Corporation (FSLIC)",
    value: "FSLIC",
  },
  { label: "Savings Association Insurance Fund (SAIF)", value: "SAIF" },
  { label: "Deposit Insurance Fund (DIF)", value: "DIF" },
  { label: "FDIC", value: "FDIC" },
];

export const selectedCharterTypes = [
  { value: "N", label: "National Member Banks (N)" },
  { value: "SM", label: "State Member Banks (SM)" },
  { value: "NM", label: "State Nonmember Banks (NM)" },
  { value: "SA", label: "Savings Associations (SA)" },
  { value: "SB", label: "Savings Banks and Savings and Loans (SB)" },
];

export const selectedTransactionTypes = [
  { label: "Assistance Transactions (A/A)", value: "A/A" },
  { label: "Open Bank Assistance (OBAM)", value: "OBAM" },
  { label: "Reprivatization (REP)", value: "REP" },
  { label: "Purchase and Assumption (P&A)", value: "P&A" },
  { label: "Purchase and Assumption (PA)", value: "PA" },
  { label: "Purchase and Assumption (PI)", value: "PI" },
  { label: "Insured Deposit Transfer (IDT)", value: "IDT" },
  { label: "Cosignment Program Institution (MGR)", value: "MGR" },
  { label: "Pay Out", value: "PO" },
];

export const selectedResolutionTypes = [
  { value: "FAILURE", label: "Failure" },
  { value: "ASSISTANCE", label: "Assistance" },
];

// NOTE: attribute name under filterChoices should correspond to state.query.filters.FILTERNAME

// Note: these intermingle failures & historical fields
// This could be separated out in the future
export const singleValues: SingleValuesFilter[] = [
  { apiField: "CERT", filterName: "cert" },
  { apiField: "MSANAMB", filterName: "msa" },
  { apiField: "ZIP", filterName: "zip" },
  { apiField: "ZIPBR", filterName: "zipbr" },
  { apiField: "STALP", filterName: "stalp" },
  { apiField: "STALPHCR", filterName: "bhcState" },
  { apiField: "TRANSNUM", filterName: "transNum" },
  { apiField: "CLASS", filterName: "bankClass" },
  { apiField: "REPDTE", filterName: "reportDate" },
  { apiField: "CB_SI", filterName: "selectedReport" },
  { apiField: "DEP", filterName: "financials" },
  { apiField: "ASSET", filterName: "financials" },
  { apiField: "REGAGNT", filterName: "primaryRegulator" },
  { apiField: "BKCLASS", filterName: "charterClass" },
  { apiField: "SPECGRP", filterName: "assetConcentration" },
  { apiField: "CHRTAGNT", filterName: "charteringAgency" },
  { apiField: "QBPRCOML", filterName: "profile" },
  { apiField: "FDICDBS", filterName: "geographic" },
  { apiField: "FDICSUPV", filterName: "supervisory" },
  { apiField: "FLDOFF", filterName: "fieldOffices" },
  { apiField: "RSSDHCR", filterName: "bhcRSSD" },
  { apiField: "YEAR", filterName: "lastYear" },
  { apiField: "YEAR", filterName: "startYear" },
  { apiField: "YEAR", filterName: "endYear" },
  { apiField: "CNTYNAMB", filterName: "county" },
  { apiField: "COUNTY", filterName: "countyInst" },
  { apiField: "STNAMEBR", filterName: "stname" },
  { apiField: "STALPBR", filterName: "stalpbr" },
  { apiField: "", filterName: "charterType" },
  { apiField: "", filterName: "commonSearch" },
  { apiField: "DOCKET", filterName: "OTSDocket" },
  { apiField: "RSSDID", filterName: "rssdid" },
];

export const searchValues: SearchValueFilter[] = [
  { apiField: "NAME", searchName: "name" },
  { apiField: "NAMEHCR", searchName: "bhcName" },
  { apiField: "STATE", searchName: "stateSearch" },
  { apiField: "CERT", searchName: "certSearch" },
  { apiField: "URL", searchName: "url" },
  { apiField: "CITY", searchName: "city" },
  { apiField: "CITYHCR", searchName: "bhcCity" },
];

export const multiSelect = [
  { apiField: "REPORT_TYPE", filterName: "eventCode" },
  { apiField: "STNUM", filterName: "selectedStates" },
  { apiField: "PSTALP", filterName: "selectedStatesAlpha" },
  { apiField: "SAVR", filterName: "selectedInsuranceFunds" },
  { apiField: "CHCLASS1", filterName: "selectedCharterTypes" },
  { apiField: "RESTYPE1", filterName: "selectedTransactionTypes" },
  { apiField: "ACTIVE", filterName: "activeStatus" },
];

export const multiValues = [{ apiField: "CERT", filterName: "multiCert" }];
export const multiUiValues = [
  { uiName: "incomeBasis" },
  { uiName: "unitType" },
  { uiName: "peerGroups" },
];

export const arrayValues = [
  { apiField: "RISDATE", filterName: "reportPeriod" },
];

export const rangeSelect: RangeSelectFilter[] = [
  {
    apiField: "apiRange",
    filterNameStart: "startDate",
    filterNameEnd: "endDate",
  },
  {
    apiField: "establishedRange",
    filterNameStart: "establishedStartRange",
    filterNameEnd: "establishedEndRange",
  },
  {
    apiField: "inactiveRange",
    filterNameStart: "inactiveStartRange",
    filterNameEnd: "inactiveEndRange",
  },
  {
    apiField: "searchDateRadio",
    filterDateRadio: "searchDateRadio",
    filterNameStart: "startDate",
    filterNameEnd: "endDate",
  },
  {
    apiField: "DEP",
    filterNameStart: "minimumRange",
    filterNameEnd: "maximumRange",
  },
  {
    apiField: "ASSET",
    filterNameStart: "minimumRange",
    filterNameEnd: "maximumRange",
  },
];

export const paginationState: PaginationFilter[] = [
  {
    apiField: "limit",
    filterName: "resultLimit",
  },
  {
    apiField: "offset",
    filterName: "pageNumber",
  },
];

export const singleUiValue: UiValue[] = [
  { uiName: "tableLevel" },
  { uiName: "createGroupType" },
  { uiName: "activeStatusExpand" },
  { uiName: "eventTypeExpand" },
  { uiName: "locationsExpand" },
  { uiName: "dateRangeExpand" },
  { uiName: "nameCertExpand" },
  { uiName: "limitEstablishedDate" },
  { uiName: "limitInactiveDate" },
  { uiName: "institutionTypeExpand" },
  { uiName: "reportingPeriodExpand" },
  { uiName: "commonSearchesExpand" },
  { uiName: "establishedDateRangeExpand" },
  { uiName: "inactiveDateRangeExpand" },
  { uiName: "regulatoryExpand" },
  { uiName: "financialsExpand" },
  { uiName: "rowsPerPage" },
  { uiName: "searchPanelExpand" },
  { uiName: "searchPillsHide" },
  { uiName: "bankfindLevel" },
  { uiName: "bankfindLevelThreeView" },
  { uiName: "branchOffices" },
  { uiName: "reportType" },
  { uiName: "aggReport" },
  { uiName: "comparisonType" },
  { uiName: "pgcStep" },
  { uiName: "institutionType" },
  { uiName: "searchPush" },
  { uiName: "savedGroupId" },
  { uiName: "savedReportId" },
  { uiName: "savedPGCSearch" },
  { uiName: "locationsSearch" },
  { uiName: "summaryTableLevelTwo" },
  { uiName: "reportType" },
  { uiName: "summaryTableType" },
  { uiName: "instType" },
  { uiName: "assetSize" },
  { uiName: "institutionTypeTimeSeries" },
  { uiName: "totalsType" },
  { uiName: "displayResults" },
  { uiName: "displayAll" },
  { uiName: "locations" },
  { uiName: "tab" },
];

export const uiFieldMappings = { singleUiValue, multiUiValues };

export const apiFieldMappings = {
  singleValues,
  searchValues,
  multiSelect,
  multiValues,
  arrayValues,
  rangeSelect,
  paginationState,
};
